import { useMutation } from '@tanstack/react-query';

import type {
  SeriesOverlap,
  ValidateUpdateSlotPayload,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useValidateUpdateSlot(hotelId?: number, calendarId?: number) {
  return useMutation({
    mutationFn: ({
      slotId,
      payload,
    }: {
      slotId: number;
      payload: ValidateUpdateSlotPayload;
    }) =>
      hotelId && calendarId
        ? (apiMutation(
            'PUT',
            {
              path: ENDPOINTS.validateUpdateSlot,
              params: {
                hotelId: hotelId.toString(),
                calendarId: calendarId.toString(),
                slotId: slotId.toString(),
              },
            },
            payload
          ) as Promise<SeriesOverlap>)
        : Promise.reject(null),
  });
}
